import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import {  Route } from 'react-router'
import App from "./App"
import { ConnectedRouter } from 'connected-react-router'
import configureStore, { history } from './configureStore'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

const store = configureStore(/* provide initial state if any */);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Route path="/" component={App}/>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));


// WEBPACK FOOTER //
// src/index.js